import LuckyWheelContainer from '@components/LuckyWheel/LuckyWheelContainer';
import LuckyWheelHistory from '@components/LuckyWheelHistory/LuckyWheelHistory';
import { useLuckyWheelCampaignDetailsQuery } from '@hooks/luckywheel/luckyWheel.gql.generated';
import { LoadingContainer } from '@sharedComponents';
import { Button } from 'antd';
import { useState } from 'react';
import { compareDate } from '@utils/datetime';

import s from './LuckyWheelCampaign.module.less';
import { truncateText } from '@utils/formatter';
import { useTranslation } from 'next-i18next';

interface LuckyWheelCampaignProps {
  id: string;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function LuckyWheelCampaign(props: LuckyWheelCampaignProps) {
  const { t: tLayout } = useTranslation('layout');

  const { id, setVisible } = props;

  const [historyVisible, setHistoryVisible] = useState(false);

  const { data: luckyWheelCampaignDetailsData, loading: luckyWheelCampaignDetailsLoading } =
    useLuckyWheelCampaignDetailsQuery({
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    });

  const luckyWheelCampaignDetails = luckyWheelCampaignDetailsData?.giftCampaignDetails;

  if (!luckyWheelCampaignDetails) return null;

  if (luckyWheelCampaignDetailsLoading) return <LoadingContainer />;

  const achievedRewards = luckyWheelCampaignDetails.achievedPrizes || [];
  const noMoreSpin = luckyWheelCampaignDetails.remainingTurns === 0;
  const showBuyMore = noMoreSpin && compareDate(luckyWheelCampaignDetails.toDate, new Date()) >= 0;

  function handleHistoryClick() {
    setHistoryVisible(true);
  }

  function handleHistoryClose() {
    setHistoryVisible(false);
  }

  return (
    <div className={s.luckyWheelCampaignRoot}>
      <LuckyWheelHistory visible={historyVisible} campaignId={id} onClose={handleHistoryClose} />
      <div className={s.campaign}>
        <div className={s.reward}>
          <p>
            {tLayout('spin.remaining_spin')}
            <br />
            <span>{luckyWheelCampaignDetails.remainingTurns}</span>
          </p>
          <p>
            {tLayout('spin.total_spin')}
            <br />
            <span>{luckyWheelCampaignDetails.totalTurns}</span>
          </p>
        </div>

        <div className={s.details}>
          <p className={s.campaignName}>
            <a>{luckyWheelCampaignDetails.campaignName}</a>
          </p>
          <div className={s.achievedRewards}>
            <div className={s.achievedRewardItemHeader}>
              <p>{tLayout('spin.bonus_prize')}</p>
              <p>{tLayout('spin.number_of_prizes')}</p>
            </div>
            {achievedRewards.map(
              reward =>
                reward.achievedQuantity > 0 && (
                  <div key={reward.id} className={s.achievedRewardItem}>
                    <p className={s.achievedrewardName}>{truncateText(reward.nameDetail, 60)}</p>
                    <p className={s.achievedRewardQuantity}>{reward.achievedQuantity}</p>
                  </div>
                ),
            )}
          </div>
        </div>
      </div>

      <div className={s.history}>
        <Button type="primary" onClick={handleHistoryClick}>
          {tLayout('spin.spinning_history')}
        </Button>
      </div>

      <div className={s.luckyWheel}>
        <LuckyWheelContainer
          campaignId={id}
          noMoreSpin={noMoreSpin}
          showBuyMore={showBuyMore}
          setVisible={setVisible}
        />
      </div>
    </div>
  );
}
